import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { useMediaQuery } from '@utils';
import { observer } from 'mobx-react';
import { useStores } from '@src/stores';
import Footer from './components/Footer';
import Header from './components/Header';

import styles from './layout.module.scss';

const Layout = observer(({ children }) => {
  const stores = useStores();
  const isMobileSize = useMediaQuery('(max-width: 599.99px)');
  useEffect(() => {
    // const screenWidth = document.documentElement.clientWidth;
    if (stores.browserInfo.isMobile || (isMobileSize && !stores.browserInfo.isMobile)) {
      document.body.style.minWidth = `auto`;
      document.body.style.overflowX = `hidden`;
    }
    
    const onChangeClientSize = () => {
      if (stores.browserInfo.isMobile || (isMobileSize && !stores.browserInfo.isMobile)) {
        const newWidth = document.documentElement.clientWidth;
        document.body.style.minWidth = `${newWidth}px`;
      }
    };

    window.addEventListener('resize', onChangeClientSize);
    return () => {
      window.removeEventListener('resize', onChangeClientSize);
    };
  }, [isMobileSize]);

  return (
    <div className={styles.Container}>
      <Header />
      {children}
      <Footer />
    </div>
  );
});

Layout.propTypes = {
  children: PropTypes.node.isRequired,
};

export default Layout;
